import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaidarshancab() {



    const cardData = {

keyword: "Mumbai Darshan Cabs",

headingDescription:
    "Mumbai Airport Cab offers comfortable and reliable Mumbai Darshan Cabs for full-day sightseeing tours, family trips, group travel, corporate outings, and tourist visits. Our Mumbai Darshan service covers all major attractions of the city with well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options. With experienced chauffeurs, flexible half-day and full-day packages, doorstep pickup and drop across Mumbai, and affordable transparent pricing, we ensure a smooth and enjoyable sightseeing experience covering the best landmarks, beaches, temples, and heritage spots of Mumbai.",

topPlaces: [
    {
        title: "Gateway of India",
        description:
            "Gateway of India is the most iconic landmark of Mumbai, located in Colaba overlooking the Arabian Sea. Built during the British era, it is a major tourist attraction where visitors enjoy ferry rides to Elephanta Caves, photography, street shopping, and the vibrant seaside atmosphere. It represents the historical and cultural identity of Mumbai."
    },
    {
        title: "Marine Drive",
        description:
            "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km long coastal promenade offering breathtaking views of the Arabian Sea. It is a peaceful place for evening walks, sunset views, and relaxation. At night, the glowing streetlights create a beautiful necklace-like pattern along the coastline."
    },
    {
        title: "Haji Ali Dargah",
        description:
            "Haji Ali Dargah is a famous spiritual landmark located on a small islet in the Arabian Sea. Connected by a narrow causeway, it attracts devotees and tourists of all religions. The peaceful environment and scenic sea views make it one of Mumbai’s most unique and visited places."
    },
    {
        title: "Siddhivinayak Temple",
        description:
            "Siddhivinayak Temple is one of Mumbai’s most revered religious sites dedicated to Lord Ganesha. Thousands of devotees visit daily to seek blessings. The temple is known for its spiritual energy, organized darshan system, and strong cultural significance."
    },
    {
        title: "Bandra-Worli Sea Link",
        description:
            "Bandra-Worli Sea Link is a modern engineering marvel connecting South Mumbai with the western suburbs. It offers a smooth driving experience with stunning views of the sea and city skyline, especially beautiful when illuminated at night."
    },
    {
        title: "Juhu Beach",
        description:
            "Juhu Beach is one of Mumbai’s most popular beaches known for its lively atmosphere, street food stalls, and sunset views. Visitors enjoy local snacks like pav bhaji, bhel puri, and vada pav while walking along the shoreline with family and friends."
    },
    {
        title: "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
        description:
            "CSMT is a UNESCO World Heritage Site and one of Mumbai’s most historic railway stations. Known for its Victorian Gothic architecture, intricate carvings, and cultural importance, it is a must-visit landmark during a Mumbai Darshan tour."
    },
    {
        title: "Colaba Causeway",
        description:
            "Colaba Causeway is a vibrant shopping street offering fashion items, souvenirs, accessories, and street food. It is a popular stop for tourists during Mumbai sightseeing tours due to its lively atmosphere and proximity to major attractions."
    },
    {
        title: "Sanjay Gandhi National Park",
        description:
            "Sanjay Gandhi National Park is a large green escape within Mumbai offering nature trails, wildlife sightings, and Kanheri Caves. It is ideal for trekking, picnics, and enjoying nature away from the busy city environment."
    },
    {
        title: "Elephanta Caves",
        description:
            "Elephanta Caves are ancient rock-cut caves located on Elephanta Island and accessible via ferry from Gateway of India. Known for detailed sculptures dedicated to Lord Shiva, it is a UNESCO World Heritage Site and a major cultural attraction in Mumbai."
    }
],



services: [
{
name: "Mumbai Darshan Cabs",
description: "Mumbai Airport Cab offers Mumbai Darshan Cabs service for comfortable and well-planned sightseeing tours across the city. Explore Mumbai’s iconic landmarks including Gateway of India, Marine Drive, Haji Ali, Siddhivinayak Temple, Juhu Beach, Colaba, CST, and other famous attractions in a safe and convenient way. We provide well-maintained AC Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Force Urbania, and luxury vehicles suitable for families, couples, solo travelers, and groups. Our professional chauffeurs ensure a smooth city tour experience with flexible half-day and full-day packages, doorstep pickup, customized itineraries, and 24x7 booking support for a hassle-free sightseeing journey in Mumbai."
},
{
name: "Mumbai Darshan Taxi",
description: "Book Mumbai Darshan Taxi with Mumbai Airport Cab for a comfortable sightseeing experience across Mumbai’s top tourist destinations. Enjoy clean vehicles, experienced drivers, affordable packages, and flexible travel timing for a perfect city tour."
},
{
name: "Mumbai Sightseeing Cab Mumbai",
description: "Mumbai Airport Cab provides Mumbai Sightseeing Cab Mumbai service for exploring popular attractions, beaches, temples, heritage sites, and city landmarks with professional chauffeurs and comfortable AC vehicles."
},
{
name: "Mumbai City Tour Cab",
description: "Choose Mumbai City Tour Cab for a complete guided travel experience across the city with customized routes, flexible schedules, and safe transportation for families and tourists."
},
{
name: "Mumbai Local Sightseeing Cab",
description: "Mumbai Local Sightseeing Cab offers convenient travel across nearby attractions and city hotspots with reliable drivers, clean vehicles, and affordable sightseeing packages."
},
{
name: "Half Day Mumbai Darshan Cab",
description: "Book Half Day Mumbai Darshan Cab for a quick city tour covering major attractions with flexible timing, professional drivers, and comfortable AC vehicles ideal for short visits."
},
{
name: "Full Day Mumbai Darshan Cab",
description: "Mumbai Airport Cab provides Full Day Mumbai Darshan Cab service for complete sightseeing coverage of Mumbai with customizable itineraries, premium vehicles, and experienced chauffeurs."
},
{
name: "Mumbai Tourist Cab Service",
description: "Mumbai Tourist Cab Service offers reliable transportation for sightseeing trips with safe driving, comfortable seating, and well-planned routes to explore Mumbai efficiently."
},
{
name: "Mumbai Heritage Tour Cab",
description: "Explore historical landmarks with Mumbai Heritage Tour Cab, covering colonial architecture, museums, forts, and cultural sites with professional guided transportation service."
},
{
name: "Mumbai Travel Sightseeing Cab",
description: "Mumbai Travel Sightseeing Cab ensures smooth and comfortable travel across all tourist destinations with flexible booking options and experienced drivers."
},
{
name: "Mumbai Darshan Tour Package",
description: "Mumbai Darshan Tour Package offers complete sightseeing solutions with curated routes, comfortable vehicles, and professional chauffeurs for a memorable city experience."
},
{
name: "Mumbai Guided City Cab",
description: "Choose Mumbai Guided City Cab for a structured sightseeing experience with route assistance, landmark coverage, and reliable transportation service."
},
{
name: "Mumbai Tourist Taxi Service",
description: "Mumbai Tourist Taxi Service provides safe and comfortable travel for visitors exploring Mumbai with affordable pricing and experienced drivers."
},
{
name: "Mumbai Explore City Cab",
description: "Mumbai Explore City Cab helps travelers discover the best attractions in Mumbai with flexible itineraries and comfortable transportation options."
},
{
name: "Mumbai Holiday Sightseeing Cab",
description: "Mumbai Holiday Sightseeing Cab is ideal for vacationers looking to explore Mumbai’s beaches, temples, markets, and heritage sites with ease."
},
{
name: "Mumbai Family Darshan Cab",
description: "Mumbai Family Darshan Cab offers safe, spacious, and comfortable travel options for families enjoying city sightseeing together."
},
{
name: "Mumbai Group Darshan Cab",
description: "Mumbai Group Darshan Cab provides large vehicle options like Tempo Traveller and Urbania for group sightseeing tours in Mumbai."
},
{
name: "Mumbai Premium Sightseeing Cab",
description: "Mumbai Premium Sightseeing Cab offers luxury vehicles, professional chauffeurs, and high-end comfort for premium city tour experiences."
},
{
name: "Mumbai Budget Darshan Cab",
description: "Mumbai Budget Darshan Cab provides affordable sightseeing options without compromising safety, comfort, or service quality."
},
{
name: "Mumbai Custom City Tour Cab",
description: "Mumbai Custom City Tour Cab allows travelers to design their own sightseeing itinerary with flexible routes, timing, and vehicle selection."
}
],

tableData: [
["Mumbai Darshan Cabs","Mumbai Darshan Taxi"],
["Mumbai Sightseeing Cab Mumbai","Mumbai City Tour Cab"],
["Mumbai Local Sightseeing Cab","Half Day Mumbai Darshan Cab"],
["Full Day Mumbai Darshan Cab","Mumbai Tourist Cab Service"],
["Mumbai Heritage Tour Cab","Mumbai Travel Sightseeing Cab"],
["Mumbai Darshan Tour Package","Mumbai Guided City Cab"],
["Mumbai Tourist Taxi Service","Mumbai Explore City Cab"],
["Mumbai Holiday Sightseeing Cab","Mumbai Family Darshan Cab"],
["Mumbai Group Darshan Cab","Mumbai Premium Sightseeing Cab"],
["Mumbai Budget Darshan Cab","Mumbai Custom City Tour Cab"]
],



whychoose: [
{
WhyChooseheading: "Reliable Mumbai Darshan Cab Service",
WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai Darshan Cabs for families, tourists, corporate guests, students, and visitors exploring the famous attractions of Mumbai."
},
{
WhyChooseheading: "Complete Mumbai Sightseeing Experience",
WhyChoosedescription: "Our Mumbai Darshan Cab Service covers popular landmarks, historical monuments, beaches, temples, shopping destinations, and cultural attractions across the city."
},
{
WhyChooseheading: "Perfect for Tourists and First-Time Visitors",
WhyChoosedescription: "Visitors can comfortably explore Mumbai's iconic destinations without worrying about transportation, parking, or route planning."
},
{
WhyChooseheading: "Wide Range of Vehicle Options",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and sightseeing requirements."
},
{
WhyChooseheading: "Customizable Mumbai Darshan Packages",
WhyChoosedescription: "Whether you need a half-day tour, full-day sightseeing package, or customized city exploration itinerary, we provide flexible travel solutions."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Pickup services are available from Mumbai Airport, hotels, railway stations, cruise terminals, offices, and residential locations across Mumbai."
},
{
WhyChooseheading: "Professional Drivers with Local Knowledge",
WhyChoosedescription: "Our experienced drivers are familiar with Mumbai's tourist attractions, routes, traffic conditions, and sightseeing locations."
},
{
WhyChooseheading: "Comfortable Travel for Families and Groups",
WhyChoosedescription: "From solo travelers to large groups, we provide suitable vehicles for comfortable city tours with ample seating and luggage space."
}
]
};

const faqData = [
{
question: "What is included in Mumbai Darshan Cab Service?",
answer: "Mumbai Darshan Cab Service includes transportation to major tourist attractions, historical landmarks, religious places, beaches, and popular sightseeing destinations in Mumbai."
},
{
question: "Which places can be covered during Mumbai Darshan?",
answer: "Popular attractions include Gateway of India, Marine Drive, Juhu Beach, Siddhivinayak Temple, Haji Ali Dargah, Bandra-Worli Sea Link, Hanging Garden, and more."
},
{
question: "Can I customize my Mumbai sightseeing itinerary?",
answer: "Yes, customers can customize their Mumbai Darshan route according to their preferred tourist attractions and available time."
},
{
question: "Which vehicle is suitable for Mumbai Darshan?",
answer: "Sedan cars, Ertiga, Innova Crysta, SUVs, and Tempo Travellers are available depending on passenger count and travel preferences."
},
{
question: "Do you provide full-day Mumbai Darshan packages?",
answer: "Yes, half-day, full-day, and customized sightseeing packages are available for individuals, families, and groups."
},
{
question: "Can tourists get pickup from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, cruise terminals, and residential locations."
},
{
question: "Are Tempo Travellers available for group sightseeing?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, school tours, corporate guests, and tourist groups."
},
{
question: "Is Mumbai Darshan suitable for first-time visitors?",
answer: "Yes, Mumbai Darshan Cab Service is ideal for visitors who want to explore the city's major attractions comfortably and efficiently."
},
{
question: "Is advance booking recommended for Mumbai Darshan?",
answer: "Yes, advance booking helps secure your preferred vehicle and ensures smooth sightseeing planning."
},
{
question: "How can I book Mumbai Darshan Cabs?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Manish Verma",
feedback:
"The Mumbai sightseeing tour was organized perfectly. We covered all major attractions comfortably and the driver was very knowledgeable about the city.",
rating: 5
},
{
id: 2,
name: "Mrs. Reema Shah",
feedback:
"Mumbai Airport Cabs provided an excellent Mumbai Darshan experience. The vehicle was clean, the itinerary was well planned, and our family enjoyed every destination.",
rating: 5
}
];











































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai Darshan Cabs",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-darshan-cab.jpg",
"description": "Book Mumbai Darshan cab service for a comfortable city sightseeing experience. Mumbai Airport Cabs offers half-day and full-day Mumbai Darshan tours with professional drivers, clean vehicles, and flexible packages covering major tourist and heritage locations across Mumbai.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-darshan-cabs"
}
};







    return (
        <div>


<Helmet>
  <title>Mumbai Darshan Cabs | City Tour & Sightseeing Taxi | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai Darshan cab service for half-day and full-day sightseeing tours. Explore Mumbai city with comfortable cars, professional drivers, and affordable sightseeing packages."
/>

<meta
 name="keywords"
 content="mumbai darshan cabs, mumbai darshan taxi, mumbai sightseeing cab mumbai, mumbai city tour cab, mumbai local sightseeing cab, half day mumbai darshan cab, full day mumbai darshan cab, mumbai tourist cab service, mumbai heritage tour cab, mumbai travel sightseeing cab, mumbai darshan tour package, mumbai guided city cab, mumbai tourist taxi service, mumbai explore city cab, mumbai holiday sightseeing cab, mumbai family darshan cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/83.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaidarshancab;